const MEDICAL_FILE_CATEGORY = Object.freeze({
  LAB:                'lab',                // blood, urine, etc.
  IMAGING:            'imaging',            // xray, mri, ct
  PRESCRIPTION:       'prescription',
  CLINICAL_NOTE:      'clinical_note',      // doctor notes, OPD notes
  DISCHARGE_SUMMARY:  'discharge_summary',
  PROCEDURE:          'procedure',          // surgery, intervention
  VITALS:             'vitals',             // reports, charts
  BILLING:            'billing',            // invoice, receipt
  ADMIN:              'admin',              // referral, consent, forms
  OTHER:              'other',
});

const MEDICAL_FILE_SOURCE_TYPE = Object.freeze({
  SINGLE_PDF:           'single_pdf',
  SINGLE_IMAGE:         'single_image',
  MULTIPLE_IMAGES_PDF:  'multiple_images_pdf',
});

const MEDICAL_FILE_STATUS = Object.freeze({
  READY:   'ready',
  DELETED: 'deleted',
  FAILED:  'failed',
});

/** Common `clinicalType` values (API stores a free string; default `other`). */
const CLINICAL_TYPE = Object.freeze({
  OTHER: 'other',
  CBC: 'cbc',
  HEMOGLOBIN: 'hemoglobin',
  LIPID_PANEL: 'lipid_panel',
  LFT: 'lft',
  RFT: 'rft',
  THYROID: 'thyroid',
  URINE_ANALYSIS: 'urine_analysis',
  XRAY: 'xray',
  CT: 'ct',
  MRI: 'mri',
  USG: 'usg',
});

module.exports = {
  MEDICAL_FILE_CATEGORY,
  MEDICAL_FILE_SOURCE_TYPE,
  MEDICAL_FILE_STATUS,
  CLINICAL_TYPE,
};
